var React = require('react');

function LinkedinInBrands (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m100.3 448h-92.9v-299.1h92.9zm-46.5-339.9c-29.7 0-53.8-24.6-53.8-54.3s24.1-53.8 53.8-53.8 53.8 24.1 53.8 53.8-24.1 54.3-53.8 54.3zm394.2 339.9h-92.7v-145.6c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7v148.1h-92.8v-299.1h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3v164.3z"}));
}

LinkedinInBrands.defaultProps = {"viewBox":"0 0 448 512"};

module.exports = LinkedinInBrands;

LinkedinInBrands.default = LinkedinInBrands;
